export default __webpack_public_path__ + "images/afpocket.75b43359a655f5650fb774ada027602b.png";